import { render, staticRenderFns } from "./shopProductType.vue?vue&type=template&id=190b6962&scoped=true"
import script from "./shopProductType.vue?vue&type=script&lang=js"
export * from "./shopProductType.vue?vue&type=script&lang=js"
import style0 from "./shopProductType.vue?vue&type=style&index=0&id=190b6962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190b6962",
  null
  
)

export default component.exports